import { ThrowStmt } from "@angular/compiler";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { faGrinTongueSquint } from "@fortawesome/free-solid-svg-icons";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { EmisorFilter } from "src/app/models/Emisor/EmisorFilter";
import { Reseller } from "src/app/models/Reseller/Reseller";
import { ResellerFilter } from "src/app/models/Reseller/ResellerFilter";
import { EmisorService } from "src/app/services/emisor.service";
import { ResellerService } from "src/app/services/reseller.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import Swal from "sweetalert2";
import { ConfigMantenedorReseller } from "./config-reseller";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
	selector: "app-mantenedor-resellers",
	templateUrl: "./mantenedor-resellers.component.html",
	styleUrls: ["./mantenedor-resellers.component.scss"],
})
export class MantenedorResellersComponent implements OnInit {
	public loading: boolean = false;
	public rowsMantenedor: Reseller[] = [];
	public page: Page = new Page();
	currentResellerModalRef: NgbModalRef;
	fullEmisoresModalRef: NgbModalRef;
	selectedReseller: Reseller;
	private filter: ResellerFilter = new ResellerFilter();
	public configLocal = ConfigMantenedorReseller;
	public rowsEmisoresReseller: Emisor[] = [];
	private filterEmisorReseller: EmisorFilter = new EmisorFilter();
	public emisoresResellerPage: Page = new Page();
	public rowsEmisoresFull: Emisor[] = [];
	private filterEmisorFull: EmisorFilter = new EmisorFilter();
	public fullEmisorPage: Page = new Page();
	private currentUserId = this.tokenService.getUser().id;
	public selectedAllEmisorsFullInPage: any = {}; // bool para la seleccion total de emisores completa en tabla
	public selected: Emisor[] = []; //array used for assigning emisores to a new reseller
	public selectedAllEmisorsOfResellerInPage: any = {};
	public selectedEmisorReseller: Emisor[] = []; //array used for selecting current assigned emisores for unassign
	constructor(private modalService: NgbModal, private resellerService: ResellerService, private utilities: UtilitiesService, private ref: ChangeDetectorRef, private tokenService: TokenStorageService, private emisorService: EmisorService, private sessionUserService: SessionUserService) {}

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.setPage({ offset: 0 });
	}

	setPage(pageInfo) {
		this.loading = true;
		this.resellerService.getDataByPage(this.filter, this.page).subscribe(
			(result) => {
				this.rowsMantenedor = result.data as Reseller[];
				this.loading = false;
				this.ref.detectChanges();
				this.setPageFromResponse(this.page, result);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en lista",
					text: "No fue posible obtener los registros de resellers. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	setPageFromResponse(currentPage: Page, data: PagedResponse<any>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	openAddResellerModal(modalRef) {
		this.currentResellerModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	addReseller(resellerRequest: Reseller) {
		this.loading = true;
		resellerRequest.usuarioId = this.tokenService.getUser().id;
		this.resellerService
			.addReseller(resellerRequest)
			.subscribe(
				(result) => {
					if (result.data) {
						this.loading = false;
						this.ref.detectChanges();
						this.currentResellerModalRef.close();
						this.setPage({ offset: 0 });
						Swal.fire({
							icon: "success",
							title: "Creación exitosa",
							text: "Se ha creado exitosamente el nuevo reseller",
						});
					}
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "error",
						title: "Error al ingresar",
						text: "NO fue posible ingresar el registro del nuevo reseller. " + this.utilities.setErrorMessageFromArray(error.error),
					});
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	openEditResellerModal(modalRef, row: Reseller) {
		this.selectedReseller = row;
		this.currentResellerModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}
	editReseller(reseller: Reseller) {
		this.loading = true;
		this.resellerService.editReseller(reseller).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Edición exitosa",
					text: "Se ha editado correctamente el reseller seleccionado",
				});
				this.setPage({ offset: 0 });
				this.currentResellerModalRef.close();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al editar",
					text: "NO fue posible editar el registro del reseller seleccionado. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	openDetailsResellerModal(modalRef, row: Reseller) {
		this.selectedReseller = row;
		this.currentResellerModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	deactivateReseller(row: Reseller) {
		this.loading = true;
		this.resellerService.deactivateReseller(row).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Reseller desactivado",
					text: "El reseller seleccionado fue desactivado",
				});
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al desactivar",
					text: "NO fue posible desactivar el reseller seleccionado. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	reactivateReseller(row: Reseller) {
		this.loading = true;
		this.resellerService.reactivateReseller(row).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Reseller activado",
					text: "El reseller seleccionado fue activado",
				});
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al activar",
					text: "NO fue posible activar el reseller seleccionado. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	openResellerEmisoresModal(modalRef, row) {
		this.selectedReseller = row;
		this.filterEmisorReseller.activo = 1;
		this.setPageEmisoresReseller({ offset: 0 });
		this.selectedEmisorReseller = [];
		this.currentResellerModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}
	assignEmisoresModal(modalRef) {
		if (this.selectedReseller == null || this.selectedReseller.resellerId == undefined) {
			Swal.fire({
				icon: "error",
				title: "Error al asignar",
				text: "No se ha seleccionado un reseller para la asignación de emisores",
			});
			return;
		}
		this.setPageEmisoresFull({ offset: 0 });
		this.selected = [];
		this.fullEmisoresModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}
	setPageEmisoresReseller(pageInfo) {
		this.loading = true;
		this.filterEmisorReseller.resellerId = this.selectedReseller.resellerId;
		this.emisorService.getDataByPage(this.filterEmisorReseller, this.emisoresResellerPage, this.currentUserId).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				this.rowsEmisoresReseller = result.data as Emisor[];
				this.setPageFromResponse(this.emisoresResellerPage, result);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Empresas",
					text: "No fue posible obtener la lista de emisores del Reseller",
				});
			}
		);
	}
	setPageEmisoresFull(pageInfo) {
		this.loading = true;
		this.filterEmisorFull.resellerId = undefined;
		this.filterEmisorFull.activo = 1;
		this.emisorService.getDataByPage(this.filterEmisorFull, this.fullEmisorPage, this.currentUserId).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				this.rowsEmisoresFull = result.data as Emisor[];
				this.setPageFromResponse(this.fullEmisorPage, result);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Emisores",
					text: "No fue posible obtener la lista de emisores del Reseller",
				});
			}
		);
	}

	selectAll(event) {
		if (!this.selectedAllEmisorsFullInPage[this.fullEmisorPage.pageNumber]) {
			if (this.selected.length > 0) {
				this.rowsEmisoresFull.map((dte) => {
					this.selected = this.selected.filter((selectedEmisor) => selectedEmisor.emisorId !== dte.emisorId);
				});
			}
			this.selected.push(...this.rowsEmisoresFull);
			this.selected = [...this.selected];
			this.selectedAllEmisorsFullInPage[this.fullEmisorPage.pageNumber] = true;
		} else {
			this.rowsEmisoresFull.map((dte) => {
				this.selected = this.selected.filter((selectedEmisor) => selectedEmisor.emisorId !== dte.emisorId);
			});
			this.selectedAllEmisorsFullInPage[this.fullEmisorPage.pageNumber] = false;
		}
	}

	selectAllEmisorReseller(event) {
		if (!this.selectedAllEmisorsOfResellerInPage[this.emisoresResellerPage.pageNumber]) {
			if (this.selectedEmisorReseller.length > 0) {
				this.rowsEmisoresReseller.map((dte) => {
					this.selectedEmisorReseller = this.selectedEmisorReseller.filter((selectedEmisor) => selectedEmisor.emisorId !== dte.emisorId);
				});
			}
			this.selectedEmisorReseller.push(...this.rowsEmisoresReseller);
			this.selectedEmisorReseller = [...this.selectedEmisorReseller];
			this.selectedAllEmisorsOfResellerInPage[this.emisoresResellerPage.pageNumber] = true;
		} else {
			this.rowsEmisoresReseller.map((dte) => {
				this.selectedEmisorReseller = this.selectedEmisorReseller.filter((selectedEmisor) => selectedEmisor.emisorId !== dte.emisorId);
			});
			this.selectedAllEmisorsOfResellerInPage[this.emisoresResellerPage.pageNumber] = false;
		}
	}

	onSelect({ selected }) {
		this.selected.splice(0, this.selected.length);
		this.selected.push(...selected);
	}

	assignEmisores() {
		if (this.selected.length <= 0) {
			Swal.fire({
				icon: "error",
				title: "Sin selección de emisores",
				text: "Intenta realizar asignación de emisores sin haber seleccionado ninguno. Seleccione un emisor o haga click en el botón Cerrar.",
			});
		}
		let arrayEmisoresId = this.selected.map((emisor) => emisor.emisorId);
		this.resellerService.assignEmisores(this.selectedReseller, arrayEmisoresId).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				this.setPageEmisoresReseller({ offset: 0 });
				this.selected = [];
				this.fullEmisoresModalRef.close();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Asignación",
					text: "No fue posible asignar la lista de emisores del Reseller",
				});
			}
		);
	}

	unassignEmisores() {
		let arrayUnassignEmisores = this.selectedEmisorReseller.map((em) => em.emisorId);
		this.loading = true;
		this.resellerService.unassignEmisores(this.selectedReseller, arrayUnassignEmisores).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				//this.setPageEmisoresReseller({ offset: 0 });
				this.selectedEmisorReseller = [];
				Swal.fire({
					icon: "success",
					title: "Liberación de Empresas",
					text: "Se ha relizado exitosamente la liberación de emisores",
				});
				this.currentResellerModalRef.close();
				this.setPage({ offset: 0 });
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Asignación",
					text: "No fue posible asignar la lista de emisores del Reseller",
				});
			}
		);
	}

	showUnassignResume() {
		if (this.selectedEmisorReseller.length <= 0) {
			Swal.fire({
				icon: "error",
				title: "Sin selección de emisores",
				text: "Intenta realizar liberación de emisores sin haber seleccionado ninguno. Seleccione uno o varios emisores para proceder a su liberación.",
			});
			return;
		}
		let htmlContent = this.setResumeListHtml(this.selectedEmisorReseller);
		Swal.fire({
			icon: "question",
			title: "Resumen de Liberación de Empresas",
			html: htmlContent,
			confirmButtonText: "Liberar",
			showCancelButton: true,
			cancelButtonText: "Cancelar",
		}).then((result) => {
			if (result.isConfirmed) {
				this.unassignEmisores();
			} else {
				return;
			}
		});
	}

	setResumeListHtml(listEmisores: Emisor[]) {
		let htmlText = '<ul style="text-align:left;">';
		listEmisores.forEach((emisor) => {
			htmlText += "<li><b>Nombre</b>:" + emisor.razonSocial + "<br> <b>RUT</b>: " + emisor.rutString + "</li>";
		});
		htmlText += "</ul>";
		return htmlText;
	}

	setPageSize() {
		this.setPage({ offset: 0 });
	}

	closeModal() {
		this.currentResellerModalRef.close();
	}

	searchElementsByFilter(event) {
		this.filter[event.criterio] = event.busqueda;
		this.filter.activo = event.registroActivo ? false : true;
		this.setPage({ offset: 0 });
	}
}
